export default {
  methods: {
    async exportJsonToCsv(csvInputData) {
      let dataParse;
      await import("vue-json-excel").then(async module => {
        let {data, columns} = csvInputData
        let fields = {};
        columns.forEach(element => {
          if (element.export || element.export === void 0)
            fields[element.label] = element.field
        });
        dataParse = await module.default.methods.getProcessedJson(
          data,
          fields
        );

      })
      let {name, unshiftCols} = csvInputData
      let csvType = "data:text/csv;charset=utf-8,%EF%BB%BF";
      let csvContent = [
        Object.keys(dataParse[0]).join(";"),
        ...dataParse.map(item => Object.values(item).join(";"))
      ]
      if (unshiftCols.length) csvContent.unshift(unshiftCols[0].join(";"));
      csvContent = csvContent
        .join("\n")
        .replace(/1(^\[)|(\]$)/gm, "");
      const outData = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", csvType + outData);
      link.setAttribute("download", `${name}.csv`);
      link.click();
    },
    saveFileAs(data) {
      let type = "data:application/json;charset=utf-8,%EF%BB%BF";
      const outData = encodeURI(data);
      const link = document.createElement("a");
      link.setAttribute("href", type + outData);
      link.setAttribute("download", `${name}.json`);
      link.click();


    }


  }
}
